import React from 'react';
import { Control, Button } from "rbx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import TextField from './TextField';

const TextFieldWithSearch = (props) => {
  const { name, label, value, onChange, focus=false, onClick, ...other } = props;

  return (
    <TextField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      focus={focus}
      {...other}
    >
      <Control>
        <Button color="" outlined onClick={onClick} title="Clique para pesquisar o endereço pelo CEP">
          <FontAwesomeIcon icon={faSearch} />
        </Button>
      </Control>
    </TextField>
  )

}

export default TextFieldWithSearch;
